import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative overflow-hidden p-6 sm:p-8" }
const _hoisted_2 = {
  key: 0,
  class: "relative z-10 flex flex-col items-center text-center"
}
const _hoisted_3 = { class: "relative mb-6 flex h-20 w-20 items-center justify-center" }
const _hoisted_4 = { class: "flex h-10 w-10 items-center justify-center rounded-full bg-[#f0f6ff] text-[#0f3557]" }
const _hoisted_5 = { class: "mt-1 text-sm font-semibold text-[#64748b]" }
const _hoisted_6 = { class: "mt-6 w-full rounded-xl border border-[#e2e8f0] bg-[#f8fbff] p-4 text-left shadow-sm" }
const _hoisted_7 = { class: "flex items-center justify-between text-xs font-bold text-[#475569]" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = { class: "font-extrabold text-[#0f3557]" }
const _hoisted_10 = { class: "mt-3 h-2 w-full overflow-hidden rounded-full bg-[#e2e8f0]" }
const _hoisted_11 = { class: "mt-4 space-y-2 text-xs" }
const _hoisted_12 = {
  key: 1,
  class: "h-3.5 w-3.5 flex-shrink-0 rounded-full border-2 border-[#2563eb] border-t-transparent animate-spin"
}
const _hoisted_13 = {
  key: 2,
  class: "h-3.5 w-3.5 flex-shrink-0 rounded-full border border-[#cbd5e1]"
}
const _hoisted_14 = {
  key: 1,
  class: "relative z-10 flex flex-col items-center text-center"
}
const _hoisted_15 = { class: "mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[#fef2f2] text-[#b42318] shadow-sm" }
const _hoisted_16 = { class: "mt-1 text-sm text-[#64748b]" }
const _hoisted_17 = { class: "mt-4 w-full rounded-xl border border-[#fecaca] bg-[#fff5f5] p-4 text-left text-xs font-semibold text-[#b42318]" }
const _hoisted_18 = { class: "mt-6 flex w-full justify-end gap-3" }

import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { Sparkles, Loader2, CheckCircle2, AlertTriangle } from "lucide-vue-next";
import { Dialog, DialogContent } from "@/components/ui/dialog";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportGenerationLoadingModal',
  props: {
    open: { type: Boolean },
    clientName: {},
    monthLabel: {},
    error: {}
  },
  emits: ["update:open", "dismiss"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const steps = [
  "Uploading assets & data sources",
  "Extracting metrics & analyzing performance",
  "Synthesizing highlights & recommendations",
  "Compiling publication layout & branding",
  "Finalizing interactive report",
];

const progressPercentage = ref(10);
const activeStepIndex = ref(0);
let intervalId: any = null;

const currentStepText = computed(() => {
  return steps[activeStepIndex.value] || steps[steps.length - 1];
});

function startProgress() {
  progressPercentage.value = 12;
  activeStepIndex.value = 0;

  if (intervalId) clearInterval(intervalId);

  intervalId = setInterval(() => {
    if (progressPercentage.value < 92) {
      // Advance percentage smoothly with a bit of randomness
      const increment = Math.floor(Math.random() * 8) + 4;
      progressPercentage.value = Math.min(progressPercentage.value + increment, 92);

      // Advance step index according to progress
      if (progressPercentage.value > 75) {
        activeStepIndex.value = 3;
      } else if (progressPercentage.value > 45) {
        activeStepIndex.value = 2;
      } else if (progressPercentage.value > 20) {
        activeStepIndex.value = 1;
      }
    }
  }, 1200);
}

function stopProgress() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}

watch(
  () => props.open,
  (isOpen) => {
    if (isOpen && !props.error) {
      startProgress();
    } else {
      stopProgress();
    }
  },
  { immediate: true }
);

watch(
  () => props.error,
  (hasErr) => {
    if (hasErr) {
      stopProgress();
    }
  }
);

onUnmounted(() => {
  stopProgress();
});

function handleUpdateOpen(value: boolean) {
  if (props.error) {
    emit("update:open", value);
    emit("dismiss");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: __props.open,
    "onUpdate:open": handleUpdateOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), {
        class: "max-w-lg overflow-hidden rounded-[1.4rem] border border-[#d8e4f0] bg-white p-0 shadow-[0_28px_80px_rgba(15,23,42,0.28)]",
        "show-close-button": !!__props.error
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "pointer-events-none absolute -right-12 -top-12 h-44 w-44 rounded-full bg-gradient-to-br from-[#2563eb]/15 to-[#38bdf8]/10 blur-2xl" }, null, -1)),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "pointer-events-none absolute -bottom-12 -left-12 h-44 w-44 rounded-full bg-gradient-to-tr from-[#0f3557]/10 to-[#60a5fa]/10 blur-2xl" }, null, -1)),
            (!__props.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute inset-0 animate-ping rounded-full bg-[#2563eb]/10" }, null, -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute inset-1 animate-spin rounded-full border-4 border-[#e2e8f0] border-t-[#0f3557] [animation-duration:1.2s]" }, null, -1)),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute inset-3 animate-spin rounded-full border-4 border-transparent border-r-[#2563eb] [animation-duration:0.8s] [animation-direction:reverse]" }, null, -1)),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(Sparkles), { class: "h-5 w-5 animate-pulse text-[#2563eb]" })
                    ])
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-xl font-black tracking-tight text-[#0f172a]" }, " Generating Monthly Report ", -1)),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(__props.clientName) + " • " + _toDisplayString(__props.monthLabel), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, [
                        _createVNode(_unref(Loader2), { class: "h-3.5 w-3.5 animate-spin text-[#2563eb]" }),
                        _createElementVNode("span", null, _toDisplayString(currentStepText.value), 1)
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(progressPercentage.value) + "%", 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        class: "h-full rounded-full bg-gradient-to-r from-[#0f3557] via-[#2563eb] to-[#38bdf8] transition-all duration-500 ease-out",
                        style: _normalizeStyle({ width: `${progressPercentage.value}%` })
                      }, null, 4)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, idx) => {
                        return _createElementVNode("div", {
                          key: idx,
                          class: _normalizeClass(["flex items-center gap-2 transition-opacity duration-300", idx <= activeStepIndex.value ? 'text-[#1e293b] font-medium' : 'text-[#94a3b8] opacity-60'])
                        }, [
                          (idx < activeStepIndex.value)
                            ? (_openBlock(), _createBlock(_unref(CheckCircle2), {
                                key: 0,
                                class: "h-3.5 w-3.5 flex-shrink-0 text-[#16a34a]"
                              }))
                            : (idx === activeStepIndex.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                              : (_openBlock(), _createElementBlock("div", _hoisted_13)),
                          _createElementVNode("span", null, _toDisplayString(step), 1)
                        ], 2)
                      }), 64))
                    ])
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mt-5 text-xs text-[#64748b]" }, " Please wait while we process metrics, render charts, and compile the final layout. ", -1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_unref(AlertTriangle), { class: "h-7 w-7" })
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-xl font-black text-[#0f172a]" }, " Report Generation Failed ", -1)),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(__props.clientName) + " • " + _toDisplayString(__props.monthLabel), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(__props.error), 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "inline-flex w-full items-center justify-center rounded-[0.9rem] bg-[#0f3557] px-4 py-2.5 text-sm font-extrabold text-white transition-colors hover:bg-[#1a4a6e]",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dismiss')))
                    }, " Return to Report Builder ")
                  ])
                ]))
          ])
        ]),
        _: 1
      }, 8, ["show-close-button"])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})